import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";

export const MONTHS_IN_YEAR = 12;

export const MONTHS_PER_PAYMENT: Partial<
	Record<ClientPortfolioPaymentFrequencyEnum, number>
> = {
	[ClientPortfolioPaymentFrequencyEnum.Monthly]: 1,
	[ClientPortfolioPaymentFrequencyEnum.Quarterly]: 3,
	[ClientPortfolioPaymentFrequencyEnum.Semiannually]: 6,
	[ClientPortfolioPaymentFrequencyEnum.Yearly]: 12,
};

export enum CurrencyCode {
	BTC = "BTC",
	CZK = "CZK",
	EUR = "EUR",
	USD = "USD",
	GBP = "GBP",
	PLN = "PLN",
	CHF = "CHF",
}
